// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29G1B","col":"styles_col__71yCW"};